import { ESuburbanEstimationCategory } from '@cian/valuation-main-filters-widget';
import { useSelector } from 'react-redux';
import { selectCategory, selectIsSuburban } from '../../../selectors/filters';
import { selectDealType } from '../../../selectors/page';
import { EDealType } from '../../../types/dealType';
import {
  FLAT_METHODIC_LINK,
  HOUSE_DESCRIPTION_TEXT,
  HOUSE_TITLE,
  LAND_DESCRIPTION_TEXT,
  LAND_TITLE,
  RENT_DESCRIPTION_TEXT,
  RENT_TITLE,
  SALE_DESCRIPTION_TEXT,
  SALE_TITLE,
  SUBURBAN_METHODIC_LINK,
} from '../static';

export function useGetTooltipContent() {
  const dealType = useSelector(selectDealType);
  const category = useSelector(selectCategory);
  const isSuburban = useSelector(selectIsSuburban);

  if (isSuburban) {
    return {
      title: ESuburbanEstimationCategory.LandSale === category ? LAND_TITLE : HOUSE_TITLE,
      text: ESuburbanEstimationCategory.LandSale === category ? LAND_DESCRIPTION_TEXT : HOUSE_DESCRIPTION_TEXT,
      link: SUBURBAN_METHODIC_LINK,
    };
  }

  return {
    title: dealType === EDealType.Sale ? SALE_TITLE : RENT_TITLE,
    text: dealType === EDealType.Sale ? SALE_DESCRIPTION_TEXT : RENT_DESCRIPTION_TEXT,
    link: FLAT_METHODIC_LINK,
  };
}
